import { Routes, Route } from "react-router-dom";
import AdminShell from "@/components/shared/AdminShell";
import VisionLogo from "@/components/shared/VisionLogo";
import {
  LayoutDashboard, Store, ShoppingCart, Users, Megaphone, Wallet,
  CreditCard, FileText, Settings, ScrollText,
} from "lucide-react";
import CentralDashboard from "@/pages/central/CentralDashboard";
import CentralTenants from "@/pages/central/CentralTenants";
import CentralOrders from "@/pages/central/CentralOrders";
import CentralCRM from "@/pages/central/CentralCRM";
import { Campaigns, Expenses, Treasury, Blog, Plans, Audit } from "@/pages/central/CentralModules";

const NAV = [
  { to: "", label: "Tableau de bord", icon: LayoutDashboard, end: true },
  { to: "boutiques", label: "Boutiques", icon: Store },
  { to: "commandes", label: "Commandes", icon: ShoppingCart },
  { to: "crm", label: "CRM", icon: Users },
  { to: "marketing", label: "Marketing", icon: Megaphone },
  { to: "tresorerie", label: "Trésorerie", icon: Wallet },
  { to: "charges", label: "Charges", icon: CreditCard },
  { to: "blog", label: "Blog", icon: FileText },
  { to: "plans", label: "Plans & Tarifs", icon: Settings },
  { to: "audit", label: "Journal d'audit", icon: ScrollText },
];

export default function CentralApp() {
  return (
    <Routes>
      <Route element={<AdminShell brand={<VisionLogo variant="dark" size={28} />} subtitle="Administration centrale" base="/admin" nav={NAV} requireRole={["super_admin"]} />}>
        <Route index element={<CentralDashboard />} />
        <Route path="boutiques" element={<CentralTenants />} />
        <Route path="commandes" element={<CentralOrders />} />
        <Route path="crm" element={<CentralCRM />} />
        <Route path="marketing" element={<Campaigns />} />
        <Route path="tresorerie" element={<Treasury />} />
        <Route path="charges" element={<Expenses />} />
        <Route path="blog" element={<Blog />} />
        <Route path="plans" element={<Plans />} />
        <Route path="audit" element={<Audit />} />
      </Route>
    </Routes>
  );
}
